import { defineComponent, computed, createBlock, openBlock, resolveDynamicComponent, mergeProps, withCtx, createElementVNode, createElementBlock, createCommentVNode, normalizeClass, toDisplayString, Fragment, renderList } from 'vue';
import _sfc_main$1 from './basler-components.es121.js';

const _hoisted_1 = {
  key: 0,
  class: "product-variant-option__subtitle"
};
const _hoisted_2 = {
  key: 1,
  class: "product-variant-option__attributes"
};
const _hoisted_3 = { class: "product-variant-option__attribute-key" };
const _hoisted_4 = { class: "product-variant-option__attribute-value" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ProductVariantPickerOption",
  props: {
    id: {},
    label: {},
    value: {},
    link: {},
    subtitle: {},
    attributes: {},
    isActive: { type: Boolean, default: false },
    isDisabled: { type: Boolean, default: false },
    showAttributes: { type: Boolean, default: false },
    showColor: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const isLink = computed(() => props.link && !props.isDisabled);
    const tag = computed(() => isLink.value ? _sfc_main$1 : "div");
    const containerClasses = computed(() => ({
      "product-variant-option": true,
      [`product-variant-option--is-active`]: props.isActive,
      [`product-variant-option--is-disabled`]: props.isDisabled,
      [`product-variant-option--is-link`]: isLink.value,
      [`product-variant-option--with-attributes`]: props.showAttributes
    }));
    const labelClasses = computed(() => ({
      "product-variant-option__label": true,
      [`product-variant-option__label--circle`]: props.showColor,
      [`product-variant-option__label--circle-${props.id}`]: props.showColor
    }));
    const onClick = () => {
      if (props.isDisabled) {
        return;
      }
      emit("update:modelValue", props.value);
    };
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(tag.value), mergeProps({ class: containerClasses.value }, isLink.value ? _ctx.link : void 0, { onClick }), {
        default: withCtx(() => [
          createElementVNode("span", {
            class: normalizeClass(labelClasses.value)
          }, toDisplayString(_ctx.label), 3),
          _ctx.subtitle ? (openBlock(), createElementBlock("span", _hoisted_1, toDisplayString(_ctx.subtitle), 1)) : createCommentVNode("", true),
          _ctx.showAttributes ? (openBlock(), createElementBlock("div", _hoisted_2, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.attributes, (attribute, index) => {
              return openBlock(), createElementBlock("div", {
                key: index,
                class: "product-variant-option__attribute"
              }, [
                createElementVNode("div", _hoisted_3, toDisplayString(attribute.label), 1),
                createElementVNode("div", _hoisted_4, toDisplayString(attribute.value), 1)
              ]);
            }), 128))
          ])) : createCommentVNode("", true)
        ]),
        _: 1
      }, 16, ["class"]);
    };
  }
});

export { _sfc_main as default };
